module.exports = __webpack_public_path__ + "img/list.ae828981.svg";